import { useTranslation } from 'react-i18next'

import { GlobeHemisphereWestIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle, SegmentedControls } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import MenuCard from '@/metrics/components/MenuCard/MenuCard'
import { getMetricsDimensionTabOptions } from '@/metrics/helpers/helpers'

import CountriesTable from './CountriesTable/CountriesTable'
import useCountriesTabs from './hooks/useCountriesTabs/useCountriesTabs'
import * as Styles from './styles'

const CountriesMetricsCards = ({
  onExport,
  countries,
  onClickCountry,
  loading,
  tableFilters,
  salesOrdersDataActivated,
  onChangeTableFilters,
  selectedCountry,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { selectedTab, setSelectedTab, columns, description } = useCountriesTabs({ salesOrdersDataActivated })

  const handleSort = value => {
    if (onChangeTableFilters) {
      const filterValueWithOrdering = tableFilters?.ordering === value ? `-${value}` : value
      onChangeTableFilters({ ...tableFilters, ordering: filterValueWithOrdering })
    }
  }

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={theme.spacing.sp16}>
        <Styles.Title>
          <GlobeHemisphereWestIcon size={24} />
          {t('Países')}
        </Styles.Title>
        <Styles.Actions>
          {salesOrdersDataActivated && (
            <SegmentedControls
              options={getMetricsDimensionTabOptions(t)}
              value={selectedTab}
              onChange={setSelectedTab}
            />
          )}
          <MenuCard cardName={t('Países')} onExport={onExport} />
        </Styles.Actions>
      </CardTitle>
      <CardDescription>{t(description)}</CardDescription>
      <CountriesTable
        loading={loading}
        countries={countries}
        columns={columns}
        onClickCountry={onClickCountry}
        onSort={handleSort}
        orderBy={tableFilters?.ordering}
        selectedCountry={selectedCountry}
      />
    </Card>
  )
}

export default CountriesMetricsCards
